import script from "./card-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./card-form.vue?vue&type=script&lang=ts&setup=true"

import "./card-form.vue?vue&type=style&index=0&id=6fd06e38&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fd06e38"]])

export default __exports__